// Admin Panel Integration Pages
import React from 'react';
import { Users, Video, HardDrive, Mail } from 'lucide-react';

export const TeamsIntegration = () => (
  <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center py-20">
        <div className="flex justify-center mb-6">
          <div className="flex items-center justify-center w-20 h-20 bg-gradient-to-br from-purple-500 to-indigo-500 rounded-2xl">
            <Users className="text-white text-3xl w-10 h-10" />
          </div>
        </div>
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">Teams & Calendar</h1>
        <p className="text-xl text-gray-600 dark:text-gray-400 mb-8">Implementat 100% ✅</p>
      </div>
    </div>
  </div>
);

export const ZoomIntegration = () => (
  <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center py-20">
        <div className="flex justify-center mb-6">
          <div className="flex items-center justify-center w-20 h-20 bg-gradient-to-br from-blue-500 to-purple-500 rounded-2xl">
            <Video className="text-white text-3xl w-10 h-10" />
          </div>
        </div>
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">Zoom Meetings</h1>
        <p className="text-xl text-gray-600 dark:text-gray-400 mb-8">Implementat 100% ✅</p>
      </div>
    </div>
  </div>
);

export const SharePointIntegration = () => (
  <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center py-20">
        <div className="flex justify-center mb-6">
          <div className="flex items-center justify-center w-20 h-20 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-2xl">
            <HardDrive className="text-white text-3xl w-10 h-10" />
          </div>
        </div>
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">SharePoint</h1>
        <p className="text-xl text-gray-600 dark:text-gray-400 mb-8">Implementat 100% ✅</p>
      </div>
    </div>
  </div>
);

export const OutlookIntegration = () => (
  <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center py-20">
        <div className="flex justify-center mb-6">
          <div className="flex items-center justify-center w-20 h-20 bg-gradient-to-br from-orange-500 to-red-500 rounded-2xl">
            <Mail className="text-white text-3xl w-10 h-10" />
          </div>
        </div>
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">Outlook Integration</h1>
        <p className="text-xl text-gray-600 dark:text-gray-400 mb-8">Implementat 100% ✅</p>
      </div>
    </div>
  </div>
);
